export default "__VITE_PUBLIC_ASSET__355442bf__"